import React from 'react'

const Homestats = ({number, text}) => {
  return (
    <div>
        <h1>{number}</h1>
        <p>{text}</p>
    </div>
  )
}

export default Homestats